export default __webpack_public_path__ + "static/media/logo.880bc37b.png";